import TabSwitcher, { TabCodes } from 'domain/TabSwitcher';

export const BASE_EXAM_PATH = 'exam';

/**
 * Special-program exam route variants.
 * Base exam (`/exam`) is shared by most programs; only special programs
 * (e.g. HFv4, future TB v4) define a custom pathSegment here.
 */
export const EXAM_ROUTE_VARIANTS = [
  {
    id: 'hfv4',
    tabCode: TabCodes.AssessmentHFv4,
    pathSegment: 'exam-hfv4',
    // Only redirect when base MFE tab is off (avoids fighting dual-enabled groups).
    whenBaseDisabled: TabCodes.MidtermAndFinalExam,
  },
];

export function resolveExamRouteVariant(state, groupId) {
  return EXAM_ROUTE_VARIANTS.find(({ tabCode, whenBaseDisabled }) => {
    if (! TabSwitcher.isTabEnabled(state, groupId, tabCode)) {
      return false;
    }

    if (whenBaseDisabled) {
      return ! TabSwitcher.isTabEnabled(state, groupId, whenBaseDisabled);
    }
    
    return true;
  });
}

export function rewriteBaseExamPath(pathname, pathSegment) {
  return pathname.replace(
    new RegExp(`/${BASE_EXAM_PATH}(?=/|$)`),
    `/${pathSegment}`
  );
}

export function getExamPathSegmentByVariantId(variantId) {
  const variant = EXAM_ROUTE_VARIANTS.find(({ id }) => id === variantId);
  return variant ? variant.pathSegment : BASE_EXAM_PATH;
}



// WEBPACK FOOTER //
// ./domain/ExamRouteVariant/index.js